import { Link } from 'react-router-dom';
import { membershipTiers } from '@/mocks/faq';

export default function MembershipSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              hth 会员权益
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              四大等级，层层升级，越用越超值
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {membershipTiers.map((tier) => (
              <div
                key={tier.name}
                className={`relative p-6 rounded-lg border-2 transition-all cursor-pointer ${
                  tier.highlight
                    ? 'border-primary-300 bg-primary-50/70'
                    : `border-background-200 bg-background-50 ${tier.borderColor} hover:border-secondary-300`
                }`}
              >
                {tier.highlight && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    最受欢迎
                  </div>
                )}

                <div className="text-center">
                  <div className={`w-14 h-14 mx-auto flex items-center justify-center rounded-full ${tier.bgColor}`}>
                    <i className={`${tier.icon} text-2xl ${tier.textColor}`}></i>
                  </div>
                  <h3 className="mt-4 text-lg font-heading font-semibold text-foreground-900">
                    {tier.name}
                  </h3>
                  <p className={`mt-2 text-xl font-bold ${tier.textColor}`}>
                    {tier.price}
                  </p>
                </div>

                <ul className="mt-5 space-y-2.5">
                  {tier.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/category/membership"
              className="whitespace-nowrap inline-flex items-center px-6 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              查看完整权益
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}